import React from "react"
import Layout from "../../components/layout"
import { Link } from "gatsby"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div>
          <div className="page-header">
            <h1>Registering an Application</h1>
          </div>
          <ol>
            <li>
              <a href="#section1">Overview</a>
            </li>
            <li>
              <a href="#section2">Registration</a>
            </li>
          </ol>
          <br />
          <div id="section1" className="panel panel-default">
            <div className="panel-heading">
              <h4 className="panel-title">1 Overview</h4>
            </div>
            <div className="panel-body">
              <p>
                To create a client application using the Avaya Spaces backend
                you must first register with us. We will then issue you the
                necessary information to have your client application
                authenticate users to Avaya Cloud Identity via OAuth2.
              </p>
            </div>
          </div>
          <div id="section2" className="panel panel-default">
            <div className="panel-heading">
              <h4 className="panel-title">2 Registration</h4>
            </div>
            <div className="panel-body">
              <p>
                Contact{" "}
                <a href="mailto:spacessupport@avaya.com">Spaces Support</a> with
                the subject line <em>[Application Registration]</em> and
                include:
              </p>
              <ol>
                <li>Product / Application name</li>
                <li>redirect_uri: One or more redirect URLs to be redirected to after authentication</li>
                <li>
                  Environment where the production / application needs to be registered:
                </li>
                <ul>
                  <li>Production</li>
                  <li>Testing</li>
                </ul>
              </ol>
              N.B.: An OAuth2 client can be registered on both production and testing environments. <br /><br />
              Upon approval of your client application we will respond with your
              client ID and secret, which will be used to perform OAuth2
              authentication for your users and Avaya Spaces.
              <p />
              <p>
                The client ID is a string that can be publicly exposed and is
                used to identify requests made by your application. The secret
                on the other hand should be kept private and is used to
                authenticate your application with Avaya Cloud Identity when requesting
                access to a user's account.
              </p>
              <p>
                After registration, you will have everything necessary to send{" "}
                <Link to="/tutorials/authorizingrequests">
                  authorized requests to Avaya Spaces
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)
